import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import Department from "../../feature-module/settings/administration/department";
import ConnectedApps from "../settings/administration/connectedApps";
import Items from "../settings/facilitymaintaince/Item/Item";
import BlankPage from "../pages/blankPage";
import Calendar from "../mainMenu/apps/calendar";
// import Currencies from "../settings/facilitymaintaince/currencies";
import DeleteRequest from "../userManagement/deleteRequest";
import AddMasterData from "../settings/vehiclemanagement/addmasterdata";
import ComingSoon from "../pages/comingSoon";
import Manageusers from "../userManagement/manageusers";
import Vehicle from "../settings/vehiclemanagement/Vehiles/ViewDashboard/VehicleDashboard";
import Login from "../auth/login";
import Register from "../auth/register";
import TwoStepVerification from "../auth/twoStepVerification";
import EmailVerification from "../auth/emailVerification";
import Success from "../auth/success";
import ResetPassword from "../auth/resetPassword";
import ForgotPassword from "../auth/forgotPassword";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import InvoiceSettings from "../settings/keymanagement/Add Keys/Keys";
import Printers from "../settings/keymanagement/Key Allocations/KeyAllocation";
import AddItemTypeAndBrand from "../settings/facilitymaintaince/Item/Item&Brand/AddItemTypeAndBrandPage";
import Notifications from "../settings/administration/rooms";
import Location from "../settings/administration/Locations/location";
import RoomRegister from "../settings/administration/Locations/RoomRegister";
import Users from "../settings/administration/users";
import Letter from "../settings/lettermanagement/Letter";
// import FloorPlanCanvas from "../settings/visitormanagement/Floor Create/FloorPlanCanvas";
import CompanySettings from "../settings/vehiclemanagement/dashboard";
import AddVehicle from "../settings/vehiclemanagement/addvehicle";
import Booking from "../settings/vehiclemanagement/booking";
import PaymentGateways from "../settings/facilitymaintaince/dashboard";
import UnderMaintenance from "../pages/underMaintenance";
import Permission from "../userManagement/permission";
import VehicleView from "../settings/vehiclemanagement/Vehiles/ViewVehicles/VehicleView";
import VehicleDashboard from "../settings/vehiclemanagement/Vehiles/ViewDashboard/VehicleDashboard"
import AddUsers from "../../../src/feature-module/settings/administration/Users/AddUsers/AddUsers"
import ViewUsers from "../../../src/feature-module/settings/administration/Users/View Users/ViewUsers"
import RecurringBooking from "../settings/vehiclemanagement/VehicleBooking/RecurringBooking"; 
import PendingApproval from "../settings/vehiclemanagement/VehicleBooking/PendingApproval";
import NewBooking from "../settings/vehiclemanagement/VehicleBooking/NewBooking";
import Dashboard from "../settings/Dashboard/Dashboard";
import Service from "../settings/vehiclemanagement/Service/Service";
import ViewRoom from "../settings/administration/Locations/ViewRoom";
import Keys from  "../settings/keymanagement/Add Keys/Keys";
import KeyAllocation from "../settings/keymanagement/Key Allocations/KeyAllocation";  
import KeyDashboard from "../settings/keymanagement/Key Dashboard/KeyDashboard";
import AddServicePage from "../settings/vehiclemanagement/Service/AddServicePage";
import AddKeyApprover from "../settings/administration/Users/AddKeyApprover.tsx/AddKeyApprover";
import KeyRequest from "../settings/keymanagement/Key Request/Keyrequest";
import DeactivateKeyApprover from "../settings/administration/Users/AddKeyApprover.tsx/DeactivateKeyApprover";
import VehicleKey from "../settings/keymanagement/Add Keys/VehicleKey";
import DepartmentLetters from "../settings/lettermanagement/DepartmentLetters";
import ParkingSlotRegister from "../settings/administration/Locations/ParkingSlotRegister";
import ViewParkingSlotModule from "../settings/administration/Locations/ViewParkingSlotModule";
import ViewParkingSlot from "../settings/administration/Locations/ViewParkingSlot";
import VisitorRequest from "../settings/visitormanagement/VisitorRequest/VisitorRequest";
import Visitor from "../settings/visitormanagement/VisitorDashboard/Visitor";
import AllBookings from "../settings/vehiclemanagement/VehicleBooking/AllBookings";
import MaintenanceTask from "../settings/facilitymaintaince/MaintainTask/MaintenanceTask";
import JobCard from "../settings/facilitymaintaince/Job_Card/JobCard";
import DashboradMaintanence from "../../feature-module/settings/facilitymaintaince/dashboard";
import ItemService from "../settings/facilitymaintaince/Item/ItemService/ItemServiceCard";
import AddEmployeeVehicle from "../settings/vehiclemanagement/Employee_Vehicle/AddEmployeeVehicle";
import RelayDevices from "../settings/administration/GateManagement/RelayDevices/RelayDevices";
import Cameras from "../settings/administration/GateManagement/Cameras/Cameras";
import Gates from "../settings/administration/GateManagement/Gates/Gates";
import GateController from "../GateController/GateController";


const route = all_routes;

export const publicRoutes = [
  {
    path: '/',
    name: 'Root',
    element: <Navigate to="/login" />,
    route: Route,
    title:'Login'
  },
      {
    path: route.newBooking,
    element: <NewBooking />,
    route: Route,
    title:'Audio Call'
  },
    {
    path: route.vehiclekey,
    element: <VehicleKey />,
    route: Route,
    title:'Vehicle Key '
  },
  {
    path: route.service,
    element: <Service />,
    route: Route,
    title:'Service'
  },
    {
    path: route.addkeyapprover,
    element: <AddKeyApprover />,
    route: Route,
    title:'Add Key Approver'
  },
  {
    path: route.maintenanceTasks,
    element: <MaintenanceTask />,
    route: Route,
    title:'MainTenance Task'
  },
  {
    path: route.itemServiceCards,
    element: <ItemService />,
    route: Route,
    title:'Item Service'
  },
  {
    path: route.keyrequest,
    element: <KeyRequest />,
    route: Route,
    title:'Key Request'
  },
  {
    path: route.deactivatekeyapprover,
    element: <DeactivateKeyApprover />,
    route: Route,
    title:'Deactivate KeyApprover'
  },

 {
    path: route.viewparkingslots,
    element: <ViewParkingSlot />,
    route: Route,
    title:'ViewParking Slot Module '
  },
{
    path: route.Visitor,
    element: <Visitor />,
    route: Route,
    title:'Visitor Dashboard' 
  },
  {
    path: route.allBookings,
    element: <AllBookings/>,
    route: Route,
    title:'All Bookings' 
  },
   {
    path: route.recurringBooking,
    element: <RecurringBooking />,
    route: Route,
    title:'Audio Call'
  },
     {
    path: route.keyAllocations,
    element: <KeyAllocation />,
    route: Route,
    title:'KeyAllocation'
  },
      {
    path: route.jobCards,
    element: <JobCard />,
    route: Route,
    title:'JobCard'
  },
     {
    path: route.visitorRequest,
    element: <VisitorRequest />,
    route: Route,
    title:'Visitor Request' },
  {
    path: route.keys,
    element: <Keys />,
    route: Route,
    title:'Keys'
  },
     {
    path: route.pendingApproval,
    element: <PendingApproval />,
    route: Route,
    title:'Audio Call'
  },
       {
    path: route.viewrooms,
    element: <ViewRoom />,
    route: Route,
    title:'View Rooms'
  },
  {
    path: route.departmentLetters,
    element: <DepartmentLetters />,
    route: Route,
    title:'Audio Call'
  },
  {
    path: route.AddMasterData,
    element: <AddMasterData />,
    route: Route,
    title:'Audio Call'
  },
  {
    path: route.addEmployeeVehicle,
    element: <AddEmployeeVehicle/>,
    route: Route,
    title:'Audio Call'
  },
   {
    path: route.AddUsers,
    element: <AddUsers />,
    route: Route,
    title:'AddUsers'
  },
  {
    path: route.ViewUsers,
    element: <ViewUsers />,
    route: Route,
    title:'ViewUsers'
  },
  {
    path: route.VehicleDashboard,
    element: <VehicleDashboard />,
    route: Route,
    title:'VehicleDashboard'
  },
   {
    path: route.Dashboard,
    element: <Dashboard />,
    route: Route,
    title:'Dashboard'
  },
   {
    path: route.VehicleView,
    element: <VehicleView />,
    route: Route,
    title:'VehicleView'
  },
  
  {
    path: route.Department,
    element: <Department/>,
    route: Route,
    title:'Departments'
  },
  {
    path: route.RelayDevices,
    element: <RelayDevices />,
    route: Route,
    title:'Relay Devices'
  },
  {
    path: route.Cameras,
    element: <Cameras />,
    route: Route,
    title:'Cameras'
  },
  {
    path: route.Gates,
    element: <Gates />,
    route: Route,
    title:'Gates'
  },
  {
    path: route.GateController,
    element: <GateController />,
    route: Route,
    title:'Gate Controller'
  },
    {
    path: route.keydashboard,
    element: <KeyDashboard/>,
    route: Route,
    title:'Key Dashboard'
  },
  {
    path: route.connectedApps,
    element: <ConnectedApps />,
    route: Route,
    title:'Connected Apps'
  },
  {
    path: route.items,
    element: <Items />,
    route: Route,
    title:'Items'
  },
    {
    path: route.addservice,
    element: <AddServicePage />,
    route: Route,
    title:'Add Service'
  },
  {
    path: route.blankPage,
    element: <BlankPage />,
    route: Route,
    title:'Blank Page'
  },
  {
    path: route.calendar,
    element: <Calendar />,
    route: Route,
    title:'Calendar'
  },
  {
    path: route.manageusers,
    element: <Manageusers />,
    route: Route,
    title:'Manage Users'
  },
  // {
  //   path: route.currencies,
  //   element: <Currencies />,
  //   route: Route,
  //   title:'Currencies'
  // },

  {
    path: route.deleteRequest,
    element: <DeleteRequest />,
    route: Route,
    title:'Delete Request'
  },
  { path: route.Vehicle,
     element: <Vehicle />,
      route: Route,
      title:'View Vehicles'
  },

  {
    path: route.invoiceSettings,
    element: <InvoiceSettings />,
    route: Route,
    title:'Invoice Settings'
  },
  {
    path: route.printers,
    element: <Printers />,
    route: Route,
    title:'Printers'
  },
  {
    path: route.items,
    element: <Items/>,
    route: Route,
    title:'Items'
  },
  // {
  //   path: route.currencies,
  //   element: <Currencies />,
  //   route: Route,
  //   title:'Currencies'
  // },
  {
    path: route.maintenanceTasksDashboard,
    element: <DashboradMaintanence />,
    route: Route,
    title:'Dashboard'
  },
  {
    path: route.additemtypeandbrand,
    element: <AddItemTypeAndBrand />,
    route: Route,
    title:'AddItemTypeAndBrand'
  },
  {
    path: route.connectedApps,
    element: <ConnectedApps />,
    route: Route,
    title:'ConnectedApps'
  },
  {
    path: route.notification,
    element: <Notifications />,
    route: Route,
    title:'Notifications'
  },
  {
    path: route.location,
    element: <Location />,
    route: Route,
    title:'Add Location'
  },
    {
    path: route.roomregister,
    element: <RoomRegister />,
    route: Route,
    title:'RoomRegister'
  },
  {
    path: route.Users,
    element: <Users />,
    route: Route,
    title:'Users'
  },
  {
    path: route.letter,
    element: <Letter />,
    route: Route,
    title:'Letter'
  },
  // {
  //   path: route.floorplanCanvas,
  //   element: <FloorPlanCanvas />,
  //   route: Route,
  //   title:'Floor Plan Canvas'
  // },
    {
    path: route.parkingslotregister,
    element: <ParkingSlotRegister />,
    route: Route,
    title:'Parking Slot Register'
  },
      {
    path: route.parkingslotregister,
    element: <ParkingSlotRegister />,
    route: Route,
    title:'Parking Slot Register'
  },
  
  {
    path: route.companySettings,
    element: <CompanySettings />,
    route: Route,
    title:'Dashboard'
  },
  {
    path: route.addvehicle,
    element: <AddVehicle />,
    route: Route,
    title:'AddVehicle'
  },
  {
    path: route.booking,
    element: <Booking />,
    route: Route,
    title:'VehicleBooking'
  },
  {
    path: route.deleteRequest,
    element: <DeleteRequest />,
    route: Route,
    title:'Delete Request'
  },
  {
    path: route.permissions,
    element: <Permission />,
    route: Route,
    title:'Permission'
  },
];

export const authRoutes = [
  {
    path: route.comingSoon,
    element: <ComingSoon />,
    route: Route,
    title:'ComingSoon'
  },
  {
    path: route.login,
    element: <Login />,
    route: Route,
    title:'Login'
  },
  {
    path: route.register,
    element: <Register />,
    route: Route,
    title:'Register'
  },
  {
    path: route.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
    title:'TwoStepVerification'
  },
  {
    path: route.emailVerification,
    element: <EmailVerification />,
    route: Route,
    title:'EmailVerification'
  },
  {
    path: route.success,
    element: <Success />,
    route: Route,
    title:'Success'
  },

  {
    path: route.resetPassword,
    element: <ResetPassword />,
    route: Route,
    title:'Reset Password'
  },
  {
    path: route.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
    title:'Forgot Password'
  },
  {
    path: route.error404,
    element: <Error404 />,
    route: Route,
    title:'Error404'
  },
  {
    path: route.error500,
    element: <Error500 />,
    route: Route,
    title:'Error500'
  },
  {
    path: route.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
    title:'Under Maintenance'
  },
];
